import {Controller} from "@hotwired/stimulus"

// A 2.FW target select is editable only while its trigger checkbox(es) are on:
// both the high and low targets follow their per-cell toggles. Otherwise the
// select is cleared and disabled. The server clears the value too, so the data
// stays consistent without JS.
export class AlarmOrderSecondFwController extends Controller {
	static targets = ["highToggle", "lowToggle", "highSelect", "lowSelect"]

	connect() {
		this.reconnect = this.reconnect.bind(this)
		window.addEventListener("turbo:morph", this.reconnect)
		this.refresh()
	}

	disconnect() {
		window.removeEventListener("turbo:morph", this.reconnect)
	}

	refresh() {
		if (this.hasHighSelectTarget) {
			this.applySelect(this.highSelectTarget, this.highToggleTargets.some((toggle) => toggle.checked))
		}
		if (this.hasLowSelectTarget) {
			this.applySelect(this.lowSelectTarget, this.lowToggleTargets.some((toggle) => toggle.checked))
		}
	}

	reconnect() {
		this.refresh()
	}

	applySelect(select, enabled) {
		const tomSelect = select.tomselect
		if (enabled) {
			tomSelect ? tomSelect.enable() : (select.disabled = false)
		} else if (tomSelect) {
			tomSelect.clear()
			tomSelect.disable()
		} else {
			select.value = ""
			select.disabled = true
		}
	}
}
